import {HttpClient, HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError, delay, of, switchMap} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {formatDistanceToNow, fromUnixTime} from "date-fns";
import {environment} from '../../environments/environment';

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('i18n')) return next(req);
  if (req.url.includes(`${window.location.protocol}//${window.location.host}`)) return next(req);

  let delayDueToRateLimitUntil: Date = new Date();
  const http = inject(HttpClient);
  // const userSessionService = inject(UserSessionService);
  const toastr = inject(ToastrService);

  req = req.clone({
    withCredentials: true,
    url: environment.api.url + req.url,
  });

  if (!document.cookie.includes('XSRF-TOKEN') && !req.url.includes('/auth/csrf-cookie')) {
    of(delayDueToRateLimitUntil).pipe(
      delay(delayDueToRateLimitUntil),
      switchMap(() => http.get('/auth/csrf-cookie', {observe: 'response'})),
      switchMap(() => {
        return next(req).pipe(
          catchError((error: HttpErrorResponse) => {
            if (error.error instanceof ErrorEvent) {
              // client-side error — no action needed, rethrown below
            } else {
              if (error.status === 401) {
                // userSessionService.logout();
              }
            }

            throw error;
          }),
        );
      }),
    ).subscribe();
  }

  return of(delayDueToRateLimitUntil)
    .pipe(
      delay(delayDueToRateLimitUntil),
      switchMap(() => next(req)),
      catchError((error: HttpErrorResponse) => {
        // if (error.status === 401 && !req.url.includes('logout')) userSessionService.logout().subscribe();

        if (error.status === 429) {
          const resetTs = error.headers.get('x-ratelimit-reset');
          if (resetTs) {
            delayDueToRateLimitUntil = fromUnixTime(parseInt(resetTs, 10));
            toastr.error('Rate limited! Please retry in: ' + formatDistanceToNow(delayDueToRateLimitUntil, {includeSeconds: true}));
          }
        }

        if ((error.status === 400 || error.status === 423) && error.error.data.error.message) {
          toastr.error(error.error.data.error.message);
        }

        throw error;
      }),
    );
};
